/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Icon_AltInputs */



/**
* | output |
* | --- |
* | "iconik icon" |
*
* @param {Iconik_Metadata_Icon_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_icon_alt = /** @type {((inputs?: Iconik_Metadata_Icon_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Icon_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "de") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "it") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "ru") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "es") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "ja") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "hi") return /** @type {LocalizedString} */ ("iconik icon")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("iconik icon")
	return /** @type {LocalizedString} */ ("iconik icon")
});